// Libs
import { Text, View, Page, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
// Interface
import { PropsType } from './documentPDF.interface';
import { images } from '~/assets';
import { ExamStatusEnum } from '~/utils/enum/base';
import moment from 'moment';
import { DATE_FORMAT } from '~/utils/constants/common';

export const DocumentPDF = (props: PropsType) => {
  const { exams, profile } = props;

  const { t } = useTranslation(['common/exam']);

  const styles = StyleSheet.create({
    page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column' },
    tbody: {
      borderColor: 'black',
      borderRightWidth: 1,
      borderBottomWidth: 1,
    },
    tbody2: { borderColor: 'black', borderLeftWidth: 1 },
    tbody3: { borderColor: 'black', borderTopWidth: 1 },
    container: {
      flexDirection: 'column',
      padding: 10,
      flex: 1,
    },
    logo: {
      width: 250,
    },
    line: {
      borderTopWidth: 5,
      borderTopColor: '#2b7abc',
      marginVertical: 24,
    },
    title: {
      fontSize: 20,
      fontWeight: 'bold',
      color: 'black',
      textAlign: 'center',
    },
    date: {
      textAlign: 'right',
      marginTop: 24,
    },
    column: {
      flexDirection: 'column',
    },
    viewInfo: {
      marginVertical: 20,
    },
    row: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    labelRowStudent: {
      width: 100,
    },
    infoRowStudent: {
      flex: 1,
    },
    labelTable: {
      fontWeight: 'bold',
    },
    paddingInfo: {
      padding: 4,
    },
  });

  const StudentInformation = () => (
    <View style={[styles.column, styles.viewInfo]}>
      <Text style={[styles.column, styles.paddingInfo, styles.labelTable, styles.tbody, styles.tbody2, styles.tbody3]}>
        {t('study_program_student_information_title')}
      </Text>

      <View style={styles.row} wrap={false}>
        <View style={[styles.labelRowStudent, styles.labelTable, styles.tbody, styles.tbody2]}>
          <Text style={styles.paddingInfo}>{t('study_program_student_information_full_name_title')}</Text>
        </View>
        <View style={[styles.infoRowStudent, styles.tbody]}>
          <Text style={styles.paddingInfo}>
            {profile.firstName} {profile.lastName}
          </Text>
        </View>
      </View>

      <View style={styles.row} wrap={false}>
        <View style={[styles.labelRowStudent, styles.labelTable, styles.tbody, styles.tbody2]}>
          <Text style={styles.paddingInfo}>{t('study_program_student_information_course_title')}</Text>
        </View>
        <View style={[styles.infoRowStudent, styles.tbody]}>
          <Text style={styles.paddingInfo}>{profile.fieldOfStudy}</Text>
        </View>
      </View>
    </View>
  );

  const ExamProgram = () => (
    <View style={[styles.column]}>
      <View style={[styles.row]} wrap={false}>
        <View style={[styles.tbody, styles.tbody, { width: '40%', borderLeftWidth: 1, borderTopWidth: 1 }]}>
          <Text style={[styles.paddingInfo, styles.labelTable]}>{t('study_program_exam_module_title')}</Text>
        </View>

        <View style={[styles.tbody, styles.tbody, { width: '15%', borderTopWidth: 1 }]}>
          <Text style={[styles.paddingInfo, styles.labelTable]}>{t('study_program_exam_point_title')}</Text>
        </View>

        <View style={[styles.tbody, styles.tbody, { width: '15%', borderTopWidth: 1 }]}>
          <Text style={[styles.paddingInfo, styles.labelTable]}>{t('study_program_exam_value_title')}</Text>
        </View>

        <View style={[styles.tbody, styles.tbody, { width: '15%', borderTopWidth: 1 }]}>
          <Text style={[styles.paddingInfo, styles.labelTable]}>{t('study_program_exam_status_title')}</Text>
        </View>

        <View style={[styles.tbody, styles.tbody, { width: '15%', borderTopWidth: 1 }]}>
          <Text style={[styles.paddingInfo, styles.labelTable]}>{t('study_program_exam_credit_title')}</Text>
        </View>
      </View>

      {exams.map((exam) => {
        return (
          <View style={styles.row} wrap={false}>
            <View style={[styles.tbody, styles.tbody, { width: '40%', borderLeftWidth: 1 }]}>
              <Text style={[styles.paddingInfo]}>{exam.moduleName}</Text>
            </View>

            <View style={[styles.tbody, styles.tbody, { width: '15%' }]}>
              <Text style={[styles.paddingInfo]}>{exam.pointValue}</Text>
            </View>

            <View style={[styles.tbody, styles.tbody, { width: '15%' }]}>
              <Text style={[styles.paddingInfo]}>{exam.value}</Text>
            </View>

            <View style={[styles.tbody, styles.tbody, { width: '15%' }]}>
              <Text style={[styles.paddingInfo]}>{exam.status === ExamStatusEnum.PASSED ? 'Passed' : 'Failed'}</Text>
            </View>

            <View style={[styles.tbody, styles.tbody, { width: '15%' }]}>
              <Text style={[styles.paddingInfo]}>{exam.credits}</Text>
            </View>
          </View>
        );
      })}
    </View>
  );

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View style={styles.container}>
          <Image style={styles.logo} source={images.commonLogoFullPositive} />

          <View style={styles.line} />

          <Text style={styles.title}>{t('study_program_title')}</Text>

          <StudentInformation />

          <ExamProgram />

          <Text style={styles.date}>
            {t('study_program_date_title')} {moment().format(DATE_FORMAT.DATE)}
          </Text>
        </View>
      </Page>
    </Document>
  );
};
